import { styles as LS } from "components/Tools/LibraryModal/styles/LibraryModal.styles"
import { masterBreakPoint } from "themes/default/breakpoints"
import { modalContent } from "themes/default/mixins"

export const styles = {
  contanier: (theme) => ({
    ...modalContent,
    overflow: "visible",
    p: 0,
    m: 0,
    minHeight: 0,
    backgroundColor: theme.palette.background.default,
  }),
  mainImage: {
    ...LS.mainImage,
  },
  closeButton: {
    position: "absolute",
    top: 10,
    left: 10,
  },
  title: (theme) => ({
    fontSize: 15,
    color: `${theme.palette.common.black}!important`,
    textAlign: "center",
    textTransform: "capitalize",
    [masterBreakPoint]: {
      fontSize: 15,
    },
  }),
  optionsContainer: (theme) => ({
    backgroundColor: theme.palette.background.paper,
    mt: `0px!important`,
    ml: `16px!important`,
    boxShadow: `none`,
  }),
  optionsContent: {
    minHeight: 0,
  },
  dialogActions: (theme) => ({
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: theme.palette.background.default,
  }),
  dialogHeader: (theme) => ({
    backgroundColor: theme.palette.background.default,
  }),
}
